import { defineField, Validators } from '@/form/useForm'
import type { UseAssetFormComputedData, UseAssetFormState } from '../types'
import { EAssetSource, EAssetType } from 'findef'
import { lockedByIr } from '../toolips'

export const nameField = (needs: string[] = [
  'asset.type',
  'asset.cryptoQuote',
  'asset.companyProfile',
  'asset.commodityQuote',
  'asset.source',
  'providerImport'
]) => {
  return defineField<UseAssetFormState, string, UseAssetFormComputedData>({
    type: 'text',
    value: '',
    label: 'Name',
    required: true,
    validators: [Validators.min(3)],
    needs: needs,
    next: (state) => {
      return {
        placeholder: (() => {
          switch (state.asset.type) {
            case EAssetType.REAL_ESTATE:
              return 'e.g. My Apartment'
            case EAssetType.ALTERNATIVE:
              return 'e.g. Mona Lisa Painting'
            case EAssetType.CASH:
              return 'e.g. Piggy Bank'
            default:
              return 'e.g. Stark Industries'
          }
        })(),
        value: (() => {
          // Priority: investment.name > companyProfile > cryptoQuote > commodityQuote > asset.name
          if (state.name) return state.name

          const company = state.asset.companyProfile
          if (company) return company.companyName
          const crypto = state.asset.cryptoQuote
          if (crypto)
            return crypto.prettyName || crypto.name || crypto.prettySymbol || crypto.symbol
          const commodity = state.asset.commodityQuote
          if (commodity) return commodity.name
          return state.asset.name
        })(),
        locked: state.asset.source === EAssetSource.IR,
        ...(state.asset.source === EAssetSource.IR
          ? lockedByIr(state)
          : {})
      }
    }
  })
}
